import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/web-push")({
  component: lazyRouteComponent(() => import("./-pages/admin.web-push")),
  head: () => ({
    meta: [
      { title: "Web Push · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
